import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../../store/PagesContext';

import BtnBack from 'components/Buttons/BtnBack';
import PoweredBy from 'routes/decision-trees/components/PoweredBy';

import styles from './styles.module.scss';

const StoryBoard = ({ pages, startAt }) => {
  const [lastPage] = useContext(PagesContext);

  const [currentPage, setCurrentPage] = useState(startAt || Object.keys(pages)[0]);

  const backPageHandler = () => setCurrentPage(lastPage);

  const renderCurrentPage = () => {
    const pageProps = pages[currentPage];
    const Page = pageProps.component;

    return <Page setCurrentPage={setCurrentPage} {...pageProps} />;
  };

  const onBackgroundClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (pages[currentPage].onBackgroundClickGoTo) {
      setCurrentPage(pages[currentPage].onBackgroundClickGoTo);
    }
  };

  return (
    <>
      {lastPage && <BtnBack onClick={backPageHandler} />}
      <div className={styles.storyboard} onClick={(e) => onBackgroundClick(e)}>
        {renderCurrentPage()}
      </div>
      <PoweredBy />
    </>
  );
};

StoryBoard.propTypes = {
  pages: PropTypes.object,
  startAt: PropTypes.string
};

export default StoryBoard;
